import React from 'react';
import '../forms.css';
import { existsAndHasLength } from '../../../helpers/array';
import { systemText } from '../../../helpers/string';
import FormLabel from '../formLabel';

const Tags = props => {
	const [tag, setTag] = React.useState('');

	const addTag = () => {
		const temp = existsAndHasLength(props.value) ? [...props.value] : [];
		if (tag && !temp.some(x => x.toLowerCase() === tag.toLowerCase())) {
			temp.push(tag.toLowerCase());
		}

		setTag('');

		if (typeof props.onChange === 'function') {
			props.onChange(temp.sort((a, b) => (a > b ? 1 : -1)));
		}
	};

	const removeTag = tag => {
		let temp = existsAndHasLength(props.value) ? [...props.value] : [];

		temp = temp.filter(x => x.toLowerCase() != tag.toLowerCase());

		if (typeof props.onChange === 'function') {
			props.onChange(temp);
		}
	};

	const checkSubmit = e => {
		if (e.key === 'Enter') {
			addTag();
		}
	};

	const {
		label,
		help,
		infoHelp,
		error,
		warning,
		id,
		mandatory,
		maxLength,
		disabled,
		placeholder,
		value,
		readonlyTags,
		step,
		type,
		inputSuffix,
		className,
		readonly,
		icon,
		...rest
	} = props;

	return (
		<div
			key={id || 'input'}
			data-testid={rest['data-testid']}
			id={id || 'input'}
			className={`form-group ${error ? 'has-error' : warning ? 'has-warning' : ''}`}
		>
			<FormLabel {...props} htmlFor={`tags-text-${id || 'input'}`} />

			<div className="flex flex-center">
				<span className="flex flex-grow">
					<input
						id={`tags-text-${id || 'input'}`}
						role="textbox"
						autoComplete="off"
						maxLength="50"
						disabled={disabled}
						placeholder={placeholder || systemText('General/Controls/Tags/Placeholder')}
						className={`flex-grow form-control ${className ? className : ''}`}
						onChange={e => setTag(e.target.value)}
						onKeyDown={e => checkSubmit(e)}
						type="text"
						value={tag}
					/>
					<button className="btn btn-primary ml5" onClick={addTag}>
						{systemText('General/Controls/Tags/Add')}
					</button>
				</span>
				{icon && <span className={`${icon} form-control-feedback`} />}
				{inputSuffix && <span className="ml10">{inputSuffix}</span>}
			</div>
			{existsAndHasLength(value) && (
				<div className="mt5">
					{value.map(tag => {
						const readonly = readonlyTags?.some(x => x === tag);
						return (
							<div
								key={`tag-${tag.replace(' ', '_')}`}
								className="mr5 label label-default"
								style={{ display: 'inline-block' }}
							>
								{tag}
								{readonly ? (
									<i className="ml5 fa fa-trash text-disabled" />
								) : (
									<i className="ml5 pointer fa fa-trash text-danger" onClick={() => removeTag(tag)} />
								)}
							</div>
						);
					})}
				</div>
			)}
			{error && typeof error !== 'boolean' && (
				<span className="help-block">{typeof error === 'function' ? error() : error}</span>
			)}
			{warning && typeof warning !== 'boolean' && (
				<span className="help-block">{typeof warning === 'function' ? warning() : warning}</span>
			)}
		</div>
	);
};

export default Tags;
